<div #mainElement style="user-select: none; outline: none; -webkit-user-drag: none;"><ng-content></ng-content></div>